module.exports = __webpack_public_path__ + "static/media/meter-moderately-aggressive.a4adac08.svg";